import * as Sentry from '@sentry/react';
import { routes } from '~/constants';
import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { announcedAutoLogoutPeriod } from '~/infra/session-storage';
import { useOnMount } from './useOnMount';
/** Syncs the authToken between multiple active browser-tabs. Makes sure all tabs are set to the same user and business. */ export function useSyncUserDataBetweenTabs() {
    const { cookies, browser: { changeLocation } } = useIoContext();
    const { setUserInfo } = useStoreActions();
    const { getState } = useStoreStatic();
    useOnMount(()=>{
        function adoptAutoLogoutPeriodAnnouncedInAnotherTab(event) {
            const announcedMinutes = announcedAutoLogoutPeriod(event);
            const { userInfo } = getState();
            if (announcedMinutes != null && userInfo != null) {
                setUserInfo(userInfo.setAutoLogoutMinutes(announcedMinutes));
            }
        }
        async function onStorageEvent(event) {
            if (cookies.didAuthTokenChange(event)) {
                Sentry.addBreadcrumb({
                    category: 'syncAuthToken',
                    data: {
                        oldValue: event.oldValue,
                        newValue: event.newValue
                    }
                });
                changeLocation(routes.home);
            }
            adoptAutoLogoutPeriodAnnouncedInAnotherTab(event);
        }
        window.addEventListener('storage', onStorageEvent);
        return ()=>{
            window.removeEventListener('storage', onStorageEvent);
        };
    });
}
